import React, { Component } from 'react';
import axios from 'axios';
import {createHTML} from './../../utils/contact';
import {ThreeDots} from 'svg-loaders-react';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { config } from '../../constants/domainConfig';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
 class ContactUs extends Component {
     constructor(props){
         super(props);
         this.state={
             Name:'',
             MobileNumber:'',
             Email:'',
             Messages:'',
             isError:false,
             isLoading:false
         }
        this.contactUs= this.contactUs.bind(this);
        this.onNameChange=this.onNameChange.bind(this);
        this.onNumberChange=this.onNumberChange.bind(this);
        this.onEmailChange=this.onEmailChange.bind(this);
        this.onMessageChange=this.onMessageChange.bind(this);
     }
     componentDidMount() {
        const contactUs = {
            en: "Contact Us",
            pt: "Contact Us",
            ar: "Contact Us",
            be: "Contact Us",
            tr: "Contact Us",
            fr: "Contact Us",
            cy: "Contact Us",
            id: "Contact Us"
            
        };
        this.props.setHeaderTitle(contactUs[config.lang] || contactUs.en);
        window.scrollTo(0, 0);
      }
     contactUs(e){
        e.preventDefault();
         const uid=this.props.access.uid;
         this.setState({
             isLoading:true
         })
        var data={
            Name:this.state.Name,
            Number:this.state.MobileNumber,
            Email:this.state.Email,
            Message:this.state.Messages,
            subdomain:window.location.hostname

        }
       var template= createHTML(data);
        axios.post('https://email-app.sam-media.com/',{
        receiver: 'okal@sam-media.com',
        subject:'Support Request',
        html:template
    }).then((response) => {
        if(response.status){
            this.props.history.push({
            pathname:`/category/vod/?uid=${uid}`,
            state:{isVisible:"true"},
        });
        }
      })
      .catch((error)=> {
        this.setState({
            isError:true,
            isLoading:false
        })
        console.log(error)
      })
    }
    onNameChange(event){
        this.setState({
            Name:event.target.value
        })
    }
    onNumberChange(event){
        let mobile = event.target.validity.valid||event.target.value===""? event.target.value :this.state.MobileNumber
        this.setState({
            MobileNumber:mobile
        })
    }
    onEmailChange(event){
        this.setState({
            Email:event.target.value
        })
    }
    onMessageChange(event){
        this.setState({
            Messages:event.target.value
        })
    }
    render() {
        return (
            <div className="contact-us-container">
                <div className="contact-section">
                    <h1>Contact Us</h1>
                    <p>Need help? Please fill out the form below and provide details of issue you are facing.We will get back to you soon.</p>
                    <form className="contact-data" onSubmit={this.contactUs}>
                        <input type="text" value={this.state.Name} onChange={this.onNameChange} placeholder="Name" required/>
                        <input type="tel"   pattern="[0-9]*" name="mobile" value={this.state.MobileNumber} onChange={this.onNumberChange} placeholder="Mobile Number"required/>
                        <input type="email" value={this.state.Email} onChange={this.onEmailChange} placeholder="Email" required/>
                        <textarea  value={this.state.Messages} onChange={this.onMessageChange} placeholder="Write Your Message"></textarea>
                        {!this.state.isLoading?
                        <button type="submit">SUBMIT</button>
                        :
                        <button type="submit"><ThreeDots style={{width:"10%"}}/></button>}
                    </form>
                </div>
                {this.state.isError?
                <div className="alertBox">
                <h3>Server Error. Please try again</h3>
            </div>:null}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setHeaderTitle,
    }, dispatch);
};

export default connect(mapStateToProps,mapDispatchToProps)(ContactUs);


// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.js